<template>
    <div>
        <div
            class="body-card-border-primary"
            :class="[screenWidth < 768 ? 'pull-center' : '']" 
            v-if="exchangeRates.length > 0">
            <div 
                v-for="(exchangeRate, index) in exchangeRates" :key="index" class="home-product-card pull-center card-border-shadow"
                :class="[exchangeRate.isFlippedCard ? 'card-rotate' : '']">
                <div v-if="!exchangeRate.isFlippedCard">
                    <div class="row">
                        <div class="d-flex align-items-center text-color-primary">
                            <h5 class="flex-grow-1">
                                <span class="text-shadow margin-left-triple">{{ ellipsis(exchangeRate.name) }}</span>

                                <b-icon-eye
                                    :id="'target-show-details-' + index" 
                                    class="icon-zoom margin-left pointer" 
                                    v-if="!exchangeRate.showDetails"
                                    v-on:click="showExchangeRateDetails(index)"/>
                                <b-icon-eye-slash
                                    :id="'target-show-details-' + index" 
                                    class="icon-zoom margin-left pointer" 
                                    v-if="exchangeRate.showDetails"
                                    v-on:click="showExchangeRateDetails(index)"/>
                            </h5>

                            <h5>
                                <b-icon-clipboard-check
                                    :id="'target-copy-paste-' + index" 
                                    class="icon-zoom pointer" 
                                    v-on:click.stop="copyToClipboard(exchangeRate)" />
                            </h5>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-6">
                            <b-badge pill variant="dark" class="badge-primary">
                                    Compra
                            </b-badge>
                        </div>

                        <div class="col-6">
                            <b-badge pill class="badge-secondary ">
                                <span class="text-color-black">
                                    Venta
                                </span>
                            </b-badge>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <span>${{ exchangeRate.purchasePrice }}</span>
                        </div>

                        <div class="col-6">
                            <span>${{ exchangeRate.salePrice }}</span> 
                        </div>
                    </div>

                    <div class="row pull-right">
                        <div class="col-7 p-0 margin-right-half" :id="'target-variation-' + index">
                            <b-icon-caret-up-fill v-if="exchangeRate.exchangeRateIndex > 0" class="icon-green margin-left-triple"/>
                            <b-icon-caret-down-fill v-else class="text-color-red margin-left-triple"/>
                            {{ exchangeRate.exchangeRateIndex }} <strong>%</strong>
                        </div>

                        <div class="col-3 p-0 font-size-s pull-left">
                            hace {{ minutesSinceLastUpdate }} min
                        </div>
                        
                        <div class="col-1 margin-left-fix">
                            <h5 class="m-0">
                                <b-icon-box-arrow-down-right
                                    :id="'target-show-details-' + index" 
                                    class="icon-zoom text-color-primary pointer"
                                    v-on:click="flipCard(index)"/>
                            </h5>
                        </div>
                    </div>

                    <b-tooltip 
                        :target="'target-copy-paste-' + index"
                        triggers="hover"
                        placement="leftbottom">
                            Copiá toda la información del contenedor
                    </b-tooltip>

                    <b-tooltip 
                        :target="'target-variation-' + index"
                        triggers="hover"
                        placement="bottom">
                            El índice de variación se compara con respecto a la apertura del mercado
                    </b-tooltip>
                </div>
                <div class="" v-else>
                    <b-tabs content-class="margin-top-fix" align="center" small card>
                        <b-tab title="Detalle" active>
                            <div class="row">
                                <p class="pull-left m-0">
                                    Último cierre: <strong>${{ exchangeRate.lastClosure }}</strong>
                                </p>
                            </div>

                            <div class="row">
                                <div class="col-10 pull-left font-size-fix">
                                    🕒 de actividad: {{ exchangeRate.activity.fromDateTime }} - {{ exchangeRate.activity.toDateTime }}
                                </div>

                                <div class="col-2 pull-right">
                                    <h5 class="m-0">
                                        <b-icon-box-arrow-down-right
                                            :id="'target-show-details-' + index" 
                                            class="icon-zoom margin-left-half text-color-primary pointer"
                                            v-on:click="flipCard(index)"/>
                                    </h5>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab class="cursor-not-allowed" title="Comparaciones" disabled>

                        </b-tab>
                    </b-tabs>
                </div>
            </div>

            <div class="p-2" v-if="showDetails" ref="details">
                <h2>Detalle del tipo de cambio</h2>

                <InConstrunction />
            </div>
        </div>
        <b-overlay :show="showOverlay" rounded="sm" class="mt-5"></b-overlay>
    </div>
</template>

<script>
import "@/assets/style.css"
import dollarRatesMocks from '@/assets/mocks/dollarRatesMock.json';
import API_ROUTES from '@/api/routes';
import InConstrunction from '@/components/Misc/InConstruction.vue'

export default {
    components: {
        InConstrunction
    },

    name: "HomeCards",

    data() {
        return {
            isSuccess: false,
            errorQuantityRequired: false,
            sizeSelected: "",
            deliveryTypeSelected: 1,
            exchangeRates: [],
            clipboardText: "El dólar {0} cotiza a ${1} para la compra y ${2} para la venta.\n\n" +
                "La variación para el dia de hoy {3} es de {4}%.\n\n" +
                "Fuente: https://dolar-info.com",
            screenWidth: window.innerWidth,
            intervalId: null,
            showOverlay: false,
            cardRotated: false,
            minutesSinceLastUpdate: 0,
            showDetails: false,
        }
    },

    async created() {
        // Mock
        //this.exchangeRates = dollarRatesMocks.data;

        await this.getExchangeRates();
        
        this.updateScreenWidth();
        window.addEventListener('resize', this.updateScreenWidth);
        
        this.intervalId = setInterval(this.getExchangeRates, 5 * 60 * 1000);

        setInterval(() => {
            this.calculateMinutesSinceLastUpdate(this.exchangeRates[0].lastUpdate);
        }, 60 * 1000); 
    },

    destroyed() {
        window.removeEventListener('resize', this.updateScreenWidth);

        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },

    methods: {
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        },

        calculateMinutesSinceLastUpdate(lastUpdate) {
            const lastUpdateDate = new Date(lastUpdate);

            const currentDate = new Date();

            currentDate.setHours(currentDate.getHours() - 3);

            const differenceMs = currentDate - lastUpdateDate;

            this.minutesSinceLastUpdate = Math.floor(differenceMs / (1000 * 60)); 
        },

        ellipsis(name) {
            return name.length > 29 ? name.substring(0, 29) + "..." : name
        },
        
        async getExchangeRates() {
            this.showOverlay = true;

            try {
                const response = await this.$axios.get(API_ROUTES.GET_EXCHANGE_RATES, {
                    params: { exchangeRateType: 1 }});

                if (response.data?.errors?.length >= 1) {
                    const errorMessages = response.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                } else {
                    // this.exchangeRates = response.data.data;
                    this.exchangeRates = response.data.data.map(rate => ({
                        ...rate,
                        isFlippedCard: false,
                        showDetails: false,
                        activity: {
                            fromDateTime: rate.id !== 6 ? '10:00' : '00:00',
                            toDateTime: rate.id !== 6 ? '15:00' : '23:59'
                        }
                    }));

                    this.calculateMinutesSinceLastUpdate(this.exchangeRates[0].lastUpdate)
                }
            } catch (error) {
                this.showNotification("error", "Error retrieving Exchange Rates: " + error);
                //console.error('Error retrieving Exchange Rates: ', error);
            } finally {
                this.showOverlay = false;
            }

            this.showOverlay = false;
        },

        async copyToClipboard(exchangeRate) {
            const template = this.clipboardText;
            const values = [exchangeRate.name, exchangeRate.purchasePrice, exchangeRate.salePrice, await this.getCurrentDate(), exchangeRate.exchangeRateIndex];

            // Replace placeholders {0}, {1}, {2}, {3} y {4} with the correct values
            const formattedString = template.replace(/\{(\d+)\}/g, (match, index) => values[index]);

            const tempInput = document.createElement('textarea');
            tempInput.value = formattedString;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            this.showNotification('success', 'Texto copiado al portapapeles');
            this.$root.$emit('bv::hide::tooltip')
        },

        async getCurrentDate() {
            const date = new Date();
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();

            return `${day}/${month}/${year}`;
        },

        flipCard(index) {
            // console.log("index: " + index);
            // console.log(this.exchangeRates);
            this.exchangeRates[index].isFlippedCard = !this.exchangeRates[index].isFlippedCard;
        },

        showExchangeRateDetails(index) {
            this.exchangeRates[index].showDetails = !this.exchangeRates[index].showDetails;
            
            for (let i = 0; i < this.exchangeRates.length; i++) {
                if (i !== index) {
                    this.exchangeRates[i].showDetails = false;
                }
            }

            this.showDetails = this.exchangeRates.some(rate =>  rate.showDetails);

            // Wait for DOM updates before scrolling
            if (this.screenWidth < 768) {
                this.$nextTick(() => {
                    if (this.showDetails) {
                        this.$refs.details.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            }
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    },

    computed: {
        
    }
}
</script>